import { useState } from 'react';
import LoginForm from '../../components/organisms/LoginForm';
import SignupForm from '../../components/organisms/SignupForm';
import homeIllustration from '../../assets/HomePageImage.svg';
import logoWhite from "../../assets/logoWhite.svg";

export default function HomePage() {
    const [isLoginMode, setLoginMode] = useState(true);

    const renderLoginForm = () => {
        if (isLoginMode) {
            return <LoginForm header='Giriş Yap' isLoginMode={isLoginMode} setLoginMode={setLoginMode} />;
        }
        return <SignupForm header='Kayıt Ol' isLoginMode={isLoginMode} setLoginMode={setLoginMode} />;
    };

    return (
        <div className='home-container'>
            <div className='img-container'>
                <div className='img-sub-container'>
                    <h1>Kalite Kontrol Sistemi</h1>
                    <img
                        className='illustration'
                        src={homeIllustration}
                        alt='Quality Control Management Illustration'
                    />
                    <img className='logo' src={logoWhite} alt='Company Logo' />
                </div>
            </div>
            <div className='form-container'>
                <div className='form-sub-container'>
                    {renderLoginForm()}
                    <div className='credentials'>
                        <p>{new Date().getFullYear()} © Tüm hakları saklıdır.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
